import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {Patient} from '../../models/patient';
import {DatePipe, formatDate} from '@angular/common';
import {
    CustomValidatorsModule,
    errorMessages,
    OapErrorMessages,
    OapStandarErrorStateMatcher,
    regExps
} from '../../modules/custom-validators/custom-validators.module';
import {TypeDocument} from '../../models/typeDocument';
import {DialogData} from '../../upload/dialog/dialog.component';
import {MessageService} from '../../services/message.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../services/authentication.service';
import {AlertService} from '../../services/alert.service';
import {DateAdapter} from '@angular/material/core';
import {PatientService} from '../../services/patient.service';
import {LoaderService} from '../../services/loader.service';
import {TypeDocumentService} from '../../services/type-document.service';
import {DisclaimerService} from '../../services/disclaimer.service';
import {TrackingService} from '../../services/tracking.service';
import {StorageService} from '../../services/storage.service';
import {debounceTime, first, map, startWith, tap} from 'rxjs/operators';
import {DialogDataImpl} from '../../models/dialogDataImpl';
import {Moment} from 'moment';
import {CompteService} from '../../services/compte.service';
import {CurrentPatientService} from '../../services/current-patient.service';
import { AdresseGouvService } from 'src/app/services/adresse-gouv.service';
import GeoCodeProperties from 'src/app/models/GeoCode/GeoCodeProperties';

@Component({
  selector: 'oap-my-profil',
  templateUrl: './my-profil.component.html',
  styleUrls: ['./my-profil.component.scss']
})
export class MyProfilComponent implements OnInit, OnDestroy {
    @ViewChild('fileDocAutre')
    editMyInfoForm: FormGroup;
    editMyAddressForm: FormGroup;
    editSocialSecurityForm: FormGroup;
    editMutuelleForm: FormGroup;

    submitMyInfoLoading = false;
    submitMyAddressLoading = false;
    submitSSLoading = false;
    submitMutuelleLoading = false;
    submittedMyInfo = false;
    submittedMyAddress = false;
    submittedSS = false;
    submittedMutuelle = false;
    patientId: number;
    firstPatientId: number;
    medecinKey: number;
    adresseKey: number;
    patientModel: Observable<Patient>;
    parentPatientModel: Observable<Patient>;
    readOnlyPhysicianName = false;
    minDate = new Date(1900, 0, 1);
    maxDate: Date = new Date(formatDate(Date.now(), 'MM/dd/yyyy', 'en'));

    matcher = new OapStandarErrorStateMatcher();
    errors = errorMessages;
    validation_messages = OapErrorMessages;

    maxDocs: Set<{ typeDocumentKey: string, maxDoc: number }> = new Set();

    typesDocuments: TypeDocument[];

    docAssuranceMaladie: DialogData;
    showHelpAttAsm = false;
    docMutuelle: DialogData;
    showHelpAttMut = false;
    docOrdo: DialogData;
    docAutre: DialogData;
    identifiantSAP: string;
    showHelpAttOrdo = true;

    isParent: boolean;
    mobileParent: string;
    phoneParent: string;
    mailParent: string;

    filterAddressesFound: Observable<GeoCodeProperties[]>;
    
    addressesFound: GeoCodeProperties[] = [];

    public mask = [/[1-4,7-8]/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /[0-9A-B]/, ' ',
        /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/];

    public disabled: boolean;
    public subscription: Subscription;

    public infoIsShowed = false;

    public currentPatient = null;
    public currentCompte = null;
    public mainPatient = null;
    public noMutuelleChecked = false;
    public associatedProfiles = null;
    public alertAddressEditedShowed = false;
  constructor(private messageService: MessageService,
              private formBuilder: FormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private authenticationService: AuthenticationService,
              private alertService: AlertService,
              private adapter: DateAdapter<any>,
              private patientService: PatientService,
              private loaderService: LoaderService,
              private typeDocumentService: TypeDocumentService,
              private disclaimer: DisclaimerService,
              private tracking: TrackingService,
              private storageService: StorageService,
              private compteService: CompteService,
              private currentPatientService: CurrentPatientService,
              private adresseGouvService: AdresseGouvService) {
      this.mobileParent = '';
      this.phoneParent = '';
      this.mailParent = '';
  }

  ngOnInit() {
      this.loaderService.showLoader();
      this.alertService.clear();
      this.messageService.sendMessage('page-my-profil');

      this.adapter.setLocale('fr');
      this.currentPatientService.putFirstPatientAsCurrent();
      this.infoPatient();
      this.subscription = this.storageService.watchStorage().subscribe((data: string) => {
          this.infoPatient();
      });
      this.tracking.DataLayer('/app/my-profil', 'Rubrique', 'Mon profil','');

      this.filterAddressesFound = this.editMyAddressForm.controls['rue'].valueChanges
      .pipe(
        debounceTime(700),
        startWith(''),
        map(value => this._searchAdresses(value))
      );
  }

  private _searchAdresses(value: string): GeoCodeProperties[] {
    let addresses = [];
    if (value.length > 5 ) {
        //console.log("search for : " + value);
        this.adresseGouvService.search(value).subscribe(res => {
            if (Array.isArray(res.features) && res.features.length > 0) {
                res.features.forEach(f => {
                    addresses.push(f.properties);
                }) 
            }  
          });
    }

    return addresses;
  }

  public onSelectAdresse(value: GeoCodeProperties) {
    //console.log('Sélection' );
    //console.log(value);

    this.editMyAddressForm.patchValue(
    {
        rue: value.name,
        codePostale: value.postcode,
        ville: value.city,
    });


  }

    ngOnDestroy() {
        if (this.subscription !== undefined) {
            this.subscription.unsubscribe();
        }
    }

    public openExternal(url: string) {
        this.disclaimer.openPopinExternal(url);
    }

    private loadDocument(patientKey: number) {
        this.typeDocumentService.getAll().pipe(first()).subscribe(tdo => {
            if (tdo) {
                this.docAssuranceMaladie = new DialogDataImpl(patientKey, tdo.find(a => a.typeDocumentKey === 'ATT_ASS_MA'));
                this.docMutuelle = new DialogDataImpl(patientKey, tdo.find(a => a.typeDocumentKey === 'ATT_MUT'));
                this.docOrdo = new DialogDataImpl(patientKey, tdo.find(a => a.typeDocumentKey === 'ORD'));
                this.docAutre = new DialogDataImpl(patientKey, tdo.find(a => a.typeDocumentKey === 'AUT_DOC'));

                tdo.forEach(f => {
                    this.maxDocs.add({typeDocumentKey: f.typeDocumentKey, maxDoc: f.nbDocumentMax});
                });
            }
        });
    }

    public onMyInfoFormSubmit(form) {
        this.submitMyInfoLoading = true;
        this.submittedMyInfo = true;

        // stop here if form is invalid
        if (this.editMyInfoForm.invalid) {
            return;
        }

        const dateNaiss: Moment = form.controls.dateNaissance.value;
        const datePipe = new DatePipe('en');
        const patientUpdate = {
            'dateNaissance': datePipe.transform(dateNaiss, 'yyyy-MM-dd'),
            'nom': form.controls.lastName.value,
            'prenom': form.controls.firstName.value,
        };
        this.patientService.updateMainPatientIdentity(patientUpdate, this.patientId)
            .pipe(first())
            .subscribe(
                obsData => {
                    this.alertService.success('Modifications enregistrées', true);
                    this.submitMyInfoLoading = false;
                },
                error => {
                    this.alertService.error(error);
                    this.submitMyInfoLoading = false;
                });
    }

    public onMyAddressFormSubmit(form) {
        this.alertAddressEditedShowed = false;
        this.submitMyAddressLoading = true;
        this.submittedMyAddress = true;

        // stop here if form is invalid
        if (this.editMyAddressForm.invalid) {
            return;
        }

        const patientUpdate = {
            'codePostal': form.controls.codePostale.value,
            'complement': form.controls.complement.value,
            'rue': form.controls.rue.value,
            'ville': form.controls.ville.value
        };

        this.patientService.updateMainPatientAddress(patientUpdate, this.patientId)
            .pipe(first())
            .subscribe(
                obsData => {
                    this.alertAddressEditedShowed = true;
                    this.submitMyAddressLoading = false;
                },
                error => {
                    this.alertService.error(error);
                    this.submitMyAddressLoading = false;
                });
    }

    public onSocialSecurityFormSubmit(form) {
        this.submitSSLoading = true;
        this.submittedSS = true;

        // stop here if form is invalid
        if (this.editSocialSecurityForm.invalid) {
            return;
        }
        let numSS: string = form.controls.numeroSecuriteSociale.value;
        // permet de supprimer les espaces contenu dans le mask mask
        // a voir pour les validator si on peut les conserver
        // TODO ajout un validator pour vérifier la clé fourni
        numSS = numSS ? numSS.replace(/\s/g, '') : null;

        const patientUpdate = {
            numeroSecuriteSociale: numSS,
            nomCPAM: form.controls.nomCPAM.value,
        };

        this.patientService.updateMainPatientSS(patientUpdate, this.patientId)
            .pipe(first())
            .subscribe(
                obsData => {
                    this.alertService.success('Modifications enregistrées', true);
                    this.submitSSLoading = false;
                },
                error => {
                    this.alertService.error(error);
                    this.submitSSLoading = false;
                });
    }

    public onMutuelleFormSubmit(form) {
        this.submitMutuelleLoading = true;
        this.submittedMutuelle = true;
        let mutuelleCodePrefectoral = form.controls.mutuelleCodePrefectoral.value;
        let mutuelleNumeroAdherent = form.controls.mutuelleNumeroAdherent.value;
        let nomMutuelle = form.controls.nomMutuelle.value;
        let mutuelleDateFinDroit: Moment = form.controls.mutuelleDateFinDroit.value;
        if (form.controls.sansMutuelle.value) {
            mutuelleCodePrefectoral = null;
            mutuelleNumeroAdherent = null;
            nomMutuelle = null;
            mutuelleDateFinDroit = null;
        }

        // stop here if form is invalid
        if (this.editMutuelleForm.invalid) {
            return;
        }
        const datePipe = new DatePipe('en');
        const patientUpdate = {
            mutuelleCodePrefectoral: mutuelleCodePrefectoral,
            mutuelleNumeroAdherent: mutuelleNumeroAdherent,
            nomMutuelle: nomMutuelle,
            mutuelleDateFinDroit: datePipe.transform(mutuelleDateFinDroit, 'yyyy-MM-dd'),
            patientSansMutuelle: form.controls.sansMutuelle.value,
        };

        this.patientService.updateMainPatientMutual(patientUpdate, this.patientId)
            .pipe(first())
            .subscribe(
                obsData => {
                    this.alertService.success('Modifications enregistrées', true);
                    this.submitMutuelleLoading = false;
                },
                error => {
                    this.alertService.error(error);
                    this.submitMutuelleLoading = false;
                });
    }

    public clickMutuelle(event) {
        this.noMutuelleChecked = !this.noMutuelleChecked;
        if ( event.checked ) {
            this.tracking.pushDataLayer('Gestion profil', 'Click', 'Pas de mutuelle');
        }
    }

    public help(id) {
        if (id === 'ATT_ASM') {
            this.showHelpAttAsm = !this.showHelpAttAsm;
        } else {
            this.showHelpAttAsm = false;
        }

        if (id === 'ATT_MUT') {
            this.showHelpAttMut = !this.showHelpAttMut;
        } else {
            this.showHelpAttMut = false;
        }

        if (id === 'ATT_ORDO') {
            this.showHelpAttOrdo = !this.showHelpAttOrdo;
        } else {
            this.showHelpAttOrdo = false;
        }

        if (!id) {
            this.showHelpAttMut = false;
            this.showHelpAttAsm = false;
        }
    }

    public onClick(e) {
        this.showHelpAttAsm = false;
        this.showHelpAttMut = false;
    }

    private infoPatient() {
        this.patientId = parseInt(JSON.parse(localStorage.getItem('patientId')));
        this.firstPatientId = parseInt(JSON.parse(localStorage.getItem('firstPatientId')));
        this.isParent = (this.patientId === this.firstPatientId);
        this.disabled = !this.isParent;
        if (this.mainPatient === null) {
            this.patientService.getPatient(this.firstPatientId).subscribe((mainPatient) => {
                this.mainPatient = mainPatient;
            });
        }
        this.loadDocument(this.patientId);

        this.editMyInfoForm = this.formBuilder.group({
            lastName: ['', [Validators.required,
                Validators.maxLength(40),
                Validators.pattern(regExps.onlyLetters)]],
            firstName: ['', [Validators.required,
                Validators.maxLength(40),
                Validators.pattern(regExps.onlyLettersAccent)]],
            dateNaissance: [''],
        });
        this.editMyAddressForm = this.formBuilder.group({
            testAutoComplete: ['', Validators.maxLength(400)],
            rue: ['', Validators.maxLength(40)],
            complement: ['', Validators.maxLength(40)],
            codePostale: ['', [Validators.maxLength(10),
                Validators.pattern(regExps.zipCode)]],
            ville: ['', Validators.maxLength(50)],
        });
        this.editSocialSecurityForm = this.formBuilder.group({
            numeroSecuriteSociale: ['', [CustomValidatorsModule.maskMinValidator(15),
                CustomValidatorsModule.checkNirKeyValidator()]],
            nomCPAM: ['', Validators.maxLength(100)],
        });
        this.editMutuelleForm = this.formBuilder.group({
            nomMutuelle: ['', Validators.maxLength(100)],
            mutuelleCodePrefectoral: ['', Validators.maxLength(20)],
            mutuelleNumeroAdherent: ['', Validators.maxLength(20)],
            mutuelleDateFinDroit: [''],
            sansMutuelle: [''],
        });

        this.patientModel = this.patientService.getPatient(this.patientId).pipe(
            tap(patient => {
                    // console.log("--- DISPLAY ---");
                    // console.log(patient);
                    this.editMyInfoForm.patchValue(
                        {
                            lastName: patient.nom,
                            firstName: patient.prenom,
                            dateNaissance: patient.dateNaissance,
                        });
                    this.editMyAddressForm.patchValue(
                        {
                            rue: patient.adresse ? patient.adresse.rue : null,
                            complement: patient.adresse ? patient.adresse.complementRue : null,
                            codePostale: patient.adresse ? patient.adresse.codePostale : null,
                            ville: patient.adresse ? patient.adresse.ville : null,
                        });
                    this.editSocialSecurityForm.patchValue(
                        {
                            numeroSecuriteSociale: patient.numeroSecuriteSociale,
                            nomCPAM: patient.nomCPAM,
                        });
                    this.editMutuelleForm.patchValue(
                    {
                        nomMutuelle: patient.nomMutuelle,
                        mutuelleNumeroAdherent: patient.mutuelleNumeroAdherent,
                        mutuelleCodePrefectoral: patient.mutuelleCodePrefectoral,
                        mutuelleDateFinDroit: patient.mutuelleDateFinDroit,
                        sansMutuelle: patient.patientSansMutuelle,
                    });
                    this.readOnlyPhysicianName = patient.medecinKey ? true : false;
                    this.medecinKey = patient.medecinKey;
                    this.adresseKey = patient.adresse ? patient.adresse.adresseKey : null;
                    this.identifiantSAP = patient.identifiantSAP;
                    this.loaderService.hideLoader();
                    this.currentPatient = patient;
                    if (this.currentPatient.patientSansMutuelle) {
                        this.noMutuelleChecked = true;
                    } else {
                        this.noMutuelleChecked = false;
                    }
                    if (this.currentCompte === null) {
                        this.compteService.getById(this.currentPatient.compteKey).subscribe((compte) => {
                            this.currentCompte = compte;
                        });
                    }
                    if (this.associatedProfiles === null) {
                        this.compteService.getPatientsAffiliated(this.currentPatient.compteKey).pipe(first()).subscribe(pat => {
                            if (pat) {
                                this.associatedProfiles = pat;
                            }
                        });
                    }
                }
            )
        );

    }

    public showInfo() {
      this.infoIsShowed = !this.infoIsShowed;
    }

    public switchPatient(patientId: number) {
        if (patientId === parseInt(JSON.parse(localStorage.getItem('firstPatientId')))) {
            this.router.navigate(['/my-profil']);
        } else {
            this.currentPatientService.updateCurrentPatient(patientId);
        }
    }
}
